/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId
    const emailAddress = this.els.email.element.value

    if (!variantId) {
      // eslint-disable-next-line no-console
      console.error('[back-in-stock] Missing variant id — cannot subscribe')
      this.showError()
      return
    }

    this.KlaviyoSubmission(variantId, emailAddress)
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    this.setLoading(true)
    this.hideError()

    try {
      // Klaviyo's legacy `/onsite/components/back-in-stock/subscribe` endpoint
      // was sunset (returns HTTP 410 Gone). This uses the current client-side
      // Back In Stock Subscriptions API.
      // https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
      const request = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-04-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: emailAddress },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        },
      )

      // A successful subscription returns 202 Accepted with an empty body, so
      // the HTTP status is the source of truth.
      if (request.ok) {
        this.showSuccess()
      } else {
        let response = {}
        try {
          response = await request.json()
        } catch (parseError) {
          response = {}
        }

        // eslint-disable-next-line no-console
        console.error('[back-in-stock] Klaviyo subscribe failed', {
          status: request.status,
          response,
        })
        this.showError()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[back-in-stock] Klaviyo request errored', error)
      this.showError()
    } finally {
      this.setLoading(false)
    }
  }

  setLoading (isLoading) {
    this.setAttribute('aria-busy', isLoading.toString())
    this.els.submit.element.disabled = isLoading
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }

  showError () {
    if (!this.els.error) return

    this.els.error.element.setAttribute('aria-hidden', false)
  }

  hideError () {
    if (!this.els.error) return

    this.els.error.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
